import { uniqueId } from 'lodash-es';
import { RefObject, useEffect, useState } from 'react';

interface UseInitMapProps {
  center: { lat: number; lng: number };
  ref: RefObject<HTMLDivElement>;
  maxZoom: number;
}

export function useInitMap({ center, maxZoom, ref }: UseInitMapProps) {
  const [map, setMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (ref && ref.current && !map) {
      setMap(
        new window.google.maps.Map(ref.current, {
          center,
          maxZoom,
          mapId: uniqueId(),
        }),
      );
    }
  }, [ref, map, center, maxZoom]);

  return map;
}
